<div class="handwritten-signature-wrapper">
  <mat-slide-toggle
    [checked]="useHandwrittenSignature"
    (change)="toggleHandwrittenSignature($event.checked)"
    color="primary"
  >
    {{ 'employee.handwritten.handwrittenTitle' | translate }}
  </mat-slide-toggle>

  <div class="handwritten-content" *ngIf="useHandwrittenSignature">
    <div class="content-row">
      <div class="upload-block">
        <h4 class="block-title">{{ 'employee.handwritten.uploadTitle' | translate }}</h4>
        <app-image-uploader
          [allowedFileExtensions]="rasterMimeTypes"
          [previewUrl]="uploadedImage"
          [description]="'employee.handwritten.chooseFile' | translate"
          [additionalDescription]="'employee.handwritten.supportedFormats' | translate"
          [previewImageStyles]="'max-height: 150px; object-fit: contain;'"
          (onFileChange)="onHandwrittenImageChange($event)"
          (onFileRemove)="removeHandwrittenImage()"
        ></app-image-uploader>
      </div>

      <div class="generate-block">
        <h4 class="block-title">{{ 'employee.handwritten.generateTitle' | translate }}</h4>
        
        <mat-form-field appearance="outline" class="signature-name-field">
          <mat-label>{{ 'employee.handwritten.nameLabel' | translate }}</mat-label>
          <input matInput [formControl]="form.get('signatureNameInput')" />
        </mat-form-field>

        <h5 class="template-chooser-title">{{ 'employee.handwritten.templateChooserTitle' | translate }}</h5>
        <div class="template-chooser">
          <div class="template-list">
            <div
              class="template-item"
              *ngFor="let style of signatureStyles; let i = index"
              [class.selected]="selectedStyle === style"
              (click)="onStyleSelected(style, i)"
            >
              <div class="radio-cell">
                <mat-radio-button
                  [value]="style"
                  [checked]="selectedStyle === style"
                  (change)="onStyleSelected(style, i)"
                >
                </mat-radio-button>
              </div>
              <div class="preview-cell">
                <img
                  *ngIf="generatedPreviews[i]"
                  [src]="generatedPreviews[i]"
                  alt="{{ 'employee.handwritten.previewAlt' | translate }}"
                  class="style-preview"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
